import { 
  ASYNC_ACTION_START,
  ASYNC_ACTION_FINISH, 
  ASYNC_ACTION_ERROR 
} from './asyncConstants';

export const asyncActionStart = (message, show = true, key) => {
  window.scrollTo(0, 0);
  return {
    type: ASYNC_ACTION_START,
    payload: {
      message: message || "",
      show,
      key,
      error: false,
    }
  }
}

export const asyncActionFinish = () => {
  return {
    type: ASYNC_ACTION_FINISH,
    payload: {
      error: false,
    }
  }
}

export const asyncActionError = (errorMessage) => {
  return {
    type: ASYNC_ACTION_ERROR,
    payload: {
      error: true,
    }
  }
}